import { Interceptor } from "@core/api/interceptors/interceptor";
import { AxiosRequestConfig } from "axios";

export const addMasterUrlInterceptor: Interceptor<AxiosRequestConfig> = {
	onFulfilled: config => ({
		...config,
		url: `${process.env.MASTER_API_URL ?? ""}${config.url}`,
	}),
};
